import { Box, Paragraph, Text } from '@zillow/constellation-10';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

interface TotalPaymentModuleProps {
  totalAmount: number;
  feeAmount?: number;
  heading?: string;
}

const TotalPaymentModule = ({ totalAmount, feeAmount, heading = 'Total payment' }: TotalPaymentModuleProps) => (
  <Box>
    <Paragraph textStyle="body-bold">{heading}</Paragraph>
    <Text>
      {centsToDollars(totalAmount)}
      {feeAmount ? ` (${centsToDollars(feeAmount)} fee)` : ''}
    </Text>
  </Box>
);

export default TotalPaymentModule;
